// src/components/Effects/BootSequence.js
import React, { useState, useEffect, useCallback } from 'react';

const BOOT_LINES = [
  { text: '', delay: 300 },
  { text: '╔══════════════════════════════════════════════════╗', delay: 50, color: 'dim' },
  { text: '║  INITIALIZING TERMINAL CONNECTION...             ║', delay: 50, color: 'dim' },
  { text: '╚══════════════════════════════════════════════════╝', delay: 50, color: 'dim' },
  { text: '', delay: 200 },
  { text: 'BIOS v3.17 — OPHIDIA GLOBAL INC. © 1987', delay: 40, color: 'dim' },
  { text: 'MEMORY TEST: 640K OK', delay: 300, color: 'green' },
  { text: 'EXTENDED MEMORY: ████████ CORRUPTED', delay: 200, color: 'red' },
  { text: '', delay: 100 },
  { text: 'DETECTING HARDWARE...', delay: 400 },
  { text: '  MODEM: USRobotics 2400 — CARRIER DETECTED', delay: 200, color: 'green' },
  { text: '  SIGNAL SOURCE: ████████ [OPHIDIA UNDERGROUND]', delay: 300, color: 'red' },
  { text: '  FREQUENCY: 1987.666 MHz', delay: 150, color: 'amber' },
  { text: '', delay: 200 },
  { text: 'ATDT 1-844-886-CRCT', delay: 600 },
  { text: 'DIALING...', delay: 400 },
  { text: 'CONNECT 2400', delay: 300, color: 'green' },
  { text: '', delay: 200 },
  { text: '▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', delay: 100, color: 'red' },
  { text: '  WARNING: RESTRICTED CONTENT', delay: 100, color: 'red' },
  { text: '▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', delay: 100, color: 'red' },
  { text: '', delay: 400 },
  { text: 'ESTABLISHING SECURE CONNECTION TO THE OPHIDIA CLOUD...', delay: 500, color: 'amber' },
  { text: '', delay: 300 },
  { text: '  ████████████████████████████████ 100%', delay: 800, color: 'green' },
  { text: '', delay: 200 },
  { text: 'CONNECTION ESTABLISHED.', delay: 300, color: 'green' },
  { text: 'TERMINAL VERSION 2.01', delay: 300, color: 'green' },
  { text: '', delay: 500 },
];

const colorMap = {
  dim: '#555555',
  green: '#00ff41',
  red: '#ff0040',
  amber: '#ffb000',
  cyan: '#00e5ff',
};

export default function BootSequence({ onComplete }) {
  const [visibleLines, setVisibleLines] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [skipBoot, setSkipBoot] = useState(false);

  const finishBoot = useCallback(() => {
    onComplete();
  }, [onComplete]);

  useEffect(() => {
    if (skipBoot) {
      finishBoot();
      return;
    }

    if (currentIndex >= BOOT_LINES.length) {
      const timer = setTimeout(finishBoot, 500);
      return () => clearTimeout(timer);
    }

    const line = BOOT_LINES[currentIndex];
    const timer = setTimeout(() => {
      setVisibleLines(prev => [...prev, line]);
      setCurrentIndex(prev => prev + 1);
    }, line.delay);

    return () => clearTimeout(timer);
  }, [currentIndex, skipBoot, finishBoot]);

  // Auto-scroll to bottom
  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, [visibleLines]);

  return (
    <div
      className="boot-sequence"
      onClick={() => setSkipBoot(true)}
      style={{
        padding: '20px',
        maxWidth: '700px',
        margin: '0 auto',
        cursor: 'pointer',
        minHeight: '100vh',
      }}
    >
      {visibleLines.map((line, i) => (
        <div
          key={i}
          style={{
            color: colorMap[line.color] || '#cccccc',
            fontFamily: "'VT323', 'Courier New', monospace",
            fontSize: '16px',
            lineHeight: '1.5',
            whiteSpace: 'pre',
            minHeight: '1.5em',
          }}
        >
          {line.text}
        </div>
      ))}

      {currentIndex < BOOT_LINES.length && (
        <span className="bbs-cursor" />
      )}

      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          color: '#555555',
          fontSize: '14px',
          fontFamily: "'VT323', monospace",
        }}
      >
        [CLICK TO SKIP]
      </div>
    </div>
  );
}